/**
 * The server's own explanation of a failed superagent request: the `message` of a
 * NestJS error body (a validation list joined). Undefined when the server gave none,
 * so the caller can fall back to its own wording.
 * @param {any} err the error superagent rejects or emits with
 * @returns {string | undefined}
 */
export const requestErrorMessage = (err) => {
  const message = err?.response?.body?.message;
  if (Array.isArray(message)) return message.join('; ') || undefined;
  return typeof message === 'string' && message ? message : undefined;
};
